export const USE_QUERY_KEYS = {
  Userinfo: 'userinfo',
}
